import * as Date from "./date";
import React from "react";
import {Link} from "react-router-dom";
import {Enums} from "./index";
import {EventType} from "./enums";

export const formatIntakeDescription = (item, withParty = true) => {
	const rows = [];
	if (withParty && item.municipalityId) {
		rows.push(<div key={'muni'}>{item.muniName + (item.muniTitle ? ' (' + item.muniTitle + ')' : '')}</div>);
	}
	if (withParty && item.partyId) {
		rows.push(<div key={'party'}>{item.partyLastName} {item.partyFirstName}</div>);
	}
	if (item.contractDate) {
		rows.push(<div key={'contract'}>Smlouva {Date.formatDate(item.contractDate)}
			{item.origContractDate && <div>(předchozí {Date.formatDate(item.origContractDate)})</div>}
		</div>);
	}
	if (item.returnReason) {
		rows.push(<div key={'reason'}><i>{item.returnReason}</i></div>)
	}
	if (item.visualDesc) {
		rows.push(<div key={'visual'}><i>{item.visualDesc}</i></div>);
	}
	if (item.chipNumber) {
		rows.push(<div key={'chipNumber'}><kbd>{item.chipNumber}</kbd></div>)
	}
	return <div>{rows}</div>;
};

export const formatExitDescription = (item) => {
	const rows = [];
	if (item.partyId) {
		rows.push(<div key={'party'}>{item.partyLastName} {item.partyFirstName}</div>);
	}
	if (item.contractDate) {
		rows.push(<div key={'contract'}>Smlouva {Date.formatDate(item.contractDate)}
			{item.origContractDate && <div>(předchozí {Date.formatDate(item.origContractDate)})</div>}
		</div>);
	}
	if (item.returnReason) {
		rows.push(<div key={'reason'}><i>{item.returnReason}</i></div>)
	}
	if (item.visualDesc) {
		rows.push(<div key={'visual'}><i>{item.visualDesc}</i></div>);
	}
	return <div title={JSON.stringify(item)}>{rows}</div>;
};

export const formatEventDescription = (item, enums, withExpiration = true) => {
	const rows = [];
	if (item.chipNumber) {
		rows.push(<div key={'chipNumber'}>{item.chipNumber}</div>);
	}
	if (item.vaccineId) {
		let v = Enums.getEnumTitle(enums, 'vaccine', item.vaccineId);
		if (v && v.indexOf('(')) {
			v = v.split('(')[0];
		}
		rows.push(<div key={'vaccineId'}>{v}</div>)
	}
	if ((item.eventDesc && item.eventType !== EventType.VA) || item.pillsAmount) {
		rows.push(<div key={'eventDesc'}>{item.eventDesc} {item.pillsAmount}</div>);
	} else if (item.eventNote) {
		rows.push(<div key={'eventNote'}>{item.eventNote}</div>);
	}
	if (withExpiration && item.expireTo) {
		if (item.expireFrom) {
			rows.push(<div key={'expire'}>{Date.format(item.expireFrom, "DD.MM.YY") + ' - ' + Date.format(item.expireTo, "DD.MM.YY")}</div>);
		} else {
			rows.push(<div key={'expire'}>{Date.format(item.expireTo, "DD.MM.YY")}</div>);
		}
	}
	return <div>{rows}</div>;
};

export const getEventExpirationClassName = (item) => {
	let from = item.expireFrom || item.expireTo;
	let to = item.expireTo || item.expireFrom;
	if (item.expireStatus !== 'APPLIED' && from && to) {
		const now = Date.format(Date.today(), 'YYYY-MM-DD');
		if (now > to) {
			return 'expiration-expired';
		} else if (now > from) {
			return 'expiration-current';
		} else if (Date.getDelta(from, now) < 30) {
			return 'expiration-near';
		}
	}
	return null;
}

export const formatDog = (item) => {
	if (!item.dogId) {
		return null;
	}
	return <Link to={{pathname: "/psi/" + item.dogId}} className="btn">{item.dogName || item.dogId}</Link>
}

export const formatParty = (item, withDetail = true) => {
	const r = [];

	if (item.municipalityId) {
		r.push(<Link key={'muni'} to={{pathname: "/vencitele/" + item.municipalityId}} className="btn">{item.muniName || item.municipalityId}</Link>);
	}

	if (item.partyId) {
		const p = [];
		if (item.partyFirstName) {
			p.push(item.partyFirstName + ' ' + item.partyLastName);
		} else {
			p.push(item.partyLastName);
		}
		if (withDetail && item.partyBirthDate) {
			p.push(Date.formatDate(item.partyBirthDate));
		}
		if (withDetail && item.partyEmail) {
			p.push(item.partyEmail);
		}
		r.push([<Link key={'party'} to={{pathname: "/vencitele/" + item.partyId}} className="btn">{p.join(', ')}</Link>]);
	}

	return <div>{r}</div>;
}

export const formatQuaran = (item, fullDate = false) => {
	const p = [];
	if (item.quaranFrom) {
		p.push(Date.format(item.quaranFrom, fullDate ? "DD.MM.YYYY" : "DD.MM.YY"));
	}
	if (item.quaranTo) {
		p.push(Date.format(item.quaranTo, fullDate ? "DD.MM.YYYY" : "DD.MM.YY"));
	}
	return p.join(' - ');
}



// WEBPACK FOOTER //
// ./src/utils/format.js